module.exports = __webpack_public_path__ + "static/img/enter-plan-picture2.ad4b65fc.png";